// ------------------------------------------------------
// Geocode cache (localStorage + Firestore optional)
// ------------------------------------------------------

import { db } from "../firebase/firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";

const CACHE_KEY = "geocode_cache_v1";
let localCache = {};

// Load cache from localStorage
try {
  const saved = localStorage.getItem(CACHE_KEY);
  localCache = saved ? JSON.parse(saved) : {};
} catch {
  localCache = {};
}

// ------------------------------------------------------
// Get cached geocode (Local + Firestore fallback)
// ------------------------------------------------------
export async function getCachedGeocode(address) {
  if (!address) return null;
  const key = address.toLowerCase().trim();

  // 1) Instant Local Cache
  if (localCache[key]) return localCache[key];

  // 2) Firestore Cache (optional but helps long-term)
  try {
    const ref = doc(db, "geocodeCache", key);
    const snap = await getDoc(ref);
    if (snap.exists()) {
      const geo = snap.data();
      localCache[key] = geo;
      saveLocalCache();
      return geo;
    }
  } catch (e) {
    console.warn("Firestore geocode cache read error:", e);
  }

  return null;
}

// ------------------------------------------------------
// Save geocode to cache (Local + Firestore optional)
// ------------------------------------------------------
export async function saveGeocodeToCache(address, geo) {
  if (!address) return;
  const key = address.toLowerCase().trim();

  // Local
  localCache[key] = geo;
  saveLocalCache();

  // Firestore
  try {
    const ref = doc(db, "geocodeCache", key);
    await setDoc(ref, geo, { merge: true });
  } catch (e) {
    console.warn("Firestore geocode cache write error:", e);
  }
}

// ------------------------------------------------------
// Persist into localStorage
// ------------------------------------------------------
function saveLocalCache() {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(localCache));
  } catch {}
}
